import { atom } from "jotai";
import { atomFamily } from "jotai/utils";
import { DefaultNodeData } from "../types";
import { nodeAtomFamily } from "./nodeAtomFamily";

export const nodeActorAtomFamily = atomFamily((nodeId: string) => {
  const baseAtom = atom((get) => {
    const node = get(nodeAtomFamily(nodeId));
    const actors = (node?.data as DefaultNodeData)?.actors;
    return actors?.[0];
  });

  baseAtom.debugLabel = `nodeActorAtomFamily(${nodeId})`;
  return baseAtom;
});
